import {Component, Vue, Watch} from "vue-property-decorator";
import {cloneDeep} from "lodash";
import { notifyError, notifySuccess } from "@/utils/notify-helper";
import {Action, Getter} from "vuex-class";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import store from '@/store/'

// Экспериментальный интерфейс
export interface IBaseFilter<T> {
  doActionExport: (filter: T) => Promise<any>;
}

@Component
export default class BaseFilter<T extends object> extends Vue /* implements IBaseFilter<T> */ {
  @Getter("systemSettings") systemSettings: any;
  @Action("getSystemSettings") actionGetSystemSettings: any;
  @Action("actionLog") actionLog: any;

  filter: T;
  filterKeys: any;
  sendFilter: T = this.defaultFilter();

  moreLoading = false
  is_last = false
  page_size = 0
  logObject: ActionLog = {};

  constructor() {
    super()
    this.filter = this.currentFilter();
    this.sendFilter = cloneDeep(this.currentFilter());
  }

  defaultFilter():T {
    return Object.create({})
  }

  storageItemName():string {
    return this.$options.name || '';
  };

  currentFilter(): T {
    if (sessionStorage.getItem(this.storageItemName()) && sessionStorage.getItem(this.storageItemName()) !== 'undefined'){
      return JSON.parse(sessionStorage.getItem(this.storageItemName()) || '')
    }
    return this.defaultFilter();
  }

  clearEmpty(){
    let filter: any = this.filter;
    let defaultFilter: any = this.defaultFilter();
    for (let field in filter){
      if (filter[field] === ''){
        this.$set(this.sendFilter, field, defaultFilter[field]);
        this.$set(this.filter, field, defaultFilter[field]);
      }
    }
  }

  async getDefaultPageSize() {
    if (this.systemSettings.length == 0) {
      try {
        await this.actionGetSystemSettings();
      } catch (error){}
    }
    this.page_size = Number(this.systemSettings?.find((e: any) => e.name == 'DEFAULT_PAGE_SIZE')?.value || 50);
    this.$set(this.filter, 'page_size', this.page_size);
  }

  async filtered() {
    if (!this.page_size) await this.getDefaultPageSize()
    this.clearEmpty();
    this.sendFilter = cloneDeep(this.filter)
    this.onFilteredAction();
  }

  onFilteredAction(nextPage: boolean = false) {

  }

  clearPersistedFilter(): void {
    sessionStorage.removeItem(this.storageItemName());
  }

  unsetFilter(field: string): void {
    let defaultFilter: any = this.defaultFilter();
    this.$set(this.filter, field, defaultFilter[field]);
    this.$set(this.sendFilter, field, defaultFilter[field]);
    this.$set(this.filter, 'page_number', 1);
    // this.filter.page_number = 1
    // this.filtered()
  }

  clear(): void {
    this.filter = this.defaultFilter()
    this.$set(this.filter, 'page_number', 1);
    // this.filter.page_number = 1
    this.filtered();
  }

  checkChangeFilter(variable: string): boolean {
    function getValue(obj: any): string | undefined {
      if (typeof obj == 'string') return obj;
      if (typeof obj == 'undefined') return obj;
      if (obj == null) return obj;
      return obj.toString()
    }

    let defaultFilter: any = this.defaultFilter();
    let filter: any = this.sendFilter;

    return getValue(filter[variable]) === getValue(defaultFilter[variable])
  }

  @Watch('sendFilter',{ immediate: true, deep: true })
  onSendFilterChanged(val: T) {
    sessionStorage.setItem(this.storageItemName(), JSON.stringify(val))
  }

  get isFilterChange(): boolean {
    let currFilter: any = this.filter;
    let defaultFilter: any = this.defaultFilter();
    let result = false;
    for (let i in defaultFilter) {
      if (i === "group_by") continue;

      if (Array.isArray(currFilter[i])) {
        if (currFilter[i].length) {
          result = true;
        }
      }
      else if (typeof currFilter[i] === "number") {
        if (currFilter[i] !== defaultFilter[i]) {
          result = true;
        }
      }
      else if (currFilter[i]) {
        if (currFilter[i] !== defaultFilter[i]) {
          result = true;
        }
      }

    }
    return result;
  }

  async doActionExport(filter: T): Promise<any> {

  };

  async newExport(object_type: string | undefined) {
    let tempFilter = cloneDeep(this.filter);
    if ((<any>this.filter)["flag"]) {
      (<any>tempFilter)["flag"] = null;
    }
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Export",
        action_status: "success",
        object_type: object_type,
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      }
      let resp = await this.doActionExport(tempFilter);
      await this.actionLog(this.logObject);
      if (resp.data.status === "Success" || resp.status == 204) {
        notifySuccess(this.$t("dialog.export").toString());
      } else {
        notifyError();
      }
    } catch(err) {
      await this.actionLog({...this.logObject, action_status: "failed"})
      notifyError(err);
    }
  }

  scrollFunction() {
    if (this.is_last) return
    let table = <HTMLElement>document.querySelector('.md-table-content');
    if (!table) return;
    let card = <HTMLElement>table.closest('.md-card-content');
    let offsetTop = card.offsetTop + table.offsetTop;
    let bottomOfTable = document.documentElement.scrollTop + window.innerHeight >= (offsetTop + table.offsetHeight);

    if (bottomOfTable && !this.moreLoading) {
      this.moreLoading = true;
      store.commit('setLoading', true);
      // this.filter.page_number++
      this.$set(this.filter, 'page_number', (<any>this.filter)['page_number'] + 1);
      this.onFilteredAction(true)
    }
  }

  scroll() {
    window.addEventListener('scroll', this.scrollFunction)
  }

  unscroll() {
    window.removeEventListener('scroll', this.scrollFunction)
  }

  beforeDestroy(): void {
    this.unscroll()
  }
}
